var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/app/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/bottom.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "query")) {
output += "\n    <div class=\"status\">Showing search results</div>\n";
;
}
else {
output += "\n    <div class=\"status\">Showing ";
if(runtime.contextOrFrameLookup(context, frame, "show_related")) {
output += "related";
;
}
else {
output += "all";
;
}
output += " assets</div>\n";
;
}
output += "\n";
if(runtime.contextOrFrameLookup(context, frame, "show_related")) {
output += "\n    <a js-show-all-assets class=\"show-all-assets-btn\" href=\"\">Show all assets</a>\n";
;
}
else {
output += "\n    ";
output += " ";
output += "\n    <a js-show-related-assets class=\"show-all-assets-btn\" href=\"\">Show related assets</a>\n";
;
}
output += "\n<div class=\"asset-library-add\">\n    <a href=\"\" js-asset-library-add-btn class=\"upload-btn\" data-url=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "asset_create_multiple_url"), env.opts.autoescape);
output += "\">Upload assets</a>\n    <input id=\"asset-library-multi-file-input\" type=\"file\" multiple />\n    <p>Add files from your computer to add to this object's asset</p>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/bottom.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/bottom.html
// module id = ./enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/bottom.html
// module chunks = main